import { TeamRecord } from '@/components/league-table/types';

export const calculateHomeStats = (matches: any[]): TeamRecord[] => {
  const homeStats = new Map<string, TeamRecord>();
  
  matches.forEach(match => {
    if (!homeStats.has(match.HomeTeam)) {
      homeStats.set(match.HomeTeam, {
        team: match.HomeTeam,
        played: 0,
        wins: 0,
        draws: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalDifference: 0,
        points: 0,
        ppg: 0,
        cleanSheets: 0,
        cleanSheetsPercentage: 0,
        btts: 0,
        bttsPercentage: 0,
        yellowCards: 0,
        redCards: 0,
        over15: 0,
        over15Percentage: 0,
        over25: 0,
        over25Percentage: 0
      });
    }

    const stats = homeStats.get(match.HomeTeam)!;
    stats.played++;
    
    stats.yellowCards += parseInt(match.HY) || 0;
    stats.redCards += parseInt(match.HR) || 0;

    const homeGoals = parseInt(match.FTHG) || 0;
    const awayGoals = parseInt(match.FTAG) || 0;
    const totalGoals = homeGoals + awayGoals;

    if (totalGoals > 1.5) {
      stats.over15++;
    }
    if (totalGoals > 2.5) {
      stats.over25++;
    }

    stats.goalsFor += homeGoals;
    stats.goalsAgainst += awayGoals;
    stats.goalDifference = stats.goalsFor - stats.goalsAgainst;

    if (awayGoals === 0) {
      stats.cleanSheets++;
    }

    if (homeGoals > 0 && awayGoals > 0) {
      stats.btts++;
    }

    if (homeGoals > awayGoals) {
      stats.wins++;
      stats.points += 3;
    } else if (homeGoals < awayGoals) {
      stats.losses++;
    } else {
      stats.draws++;
      stats.points += 1;
    }

    stats.ppg = stats.points / stats.played;
    stats.cleanSheetsPercentage = (stats.cleanSheets / stats.played) * 100;
    stats.bttsPercentage = (stats.btts / stats.played) * 100;
    stats.over15Percentage = (stats.over15 / stats.played) * 100;
    stats.over25Percentage = (stats.over25 / stats.played) * 100;

    homeStats.set(match.HomeTeam, stats);
  });

  return Array.from(homeStats.values());
};

export const calculateAwayStats = (matches: any[]): TeamRecord[] => {
  const awayStats = new Map<string, TeamRecord>();
  
  matches.forEach(match => {
    if (!awayStats.has(match.AwayTeam)) {
      awayStats.set(match.AwayTeam, {
        team: match.AwayTeam,
        played: 0,
        wins: 0,
        draws: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalDifference: 0,
        points: 0,
        ppg: 0,
        cleanSheets: 0,
        cleanSheetsPercentage: 0,
        btts: 0,
        bttsPercentage: 0,
        yellowCards: 0,
        redCards: 0,
        over15: 0,
        over15Percentage: 0,
        over25: 0,
        over25Percentage: 0
      });
    }

    const stats = awayStats.get(match.AwayTeam)!;
    stats.played++;
    
    stats.yellowCards += parseInt(match.AY) || 0;
    stats.redCards += parseInt(match.AR) || 0;

    const homeGoals = parseInt(match.FTHG) || 0;
    const awayGoals = parseInt(match.FTAG) || 0;
    const totalGoals = homeGoals + awayGoals;

    if (totalGoals > 1.5) {
      stats.over15++;
    }
    if (totalGoals > 2.5) {
      stats.over25++;
    }

    stats.goalsFor += awayGoals;
    stats.goalsAgainst += homeGoals;
    stats.goalDifference = stats.goalsFor - stats.goalsAgainst;

    if (homeGoals === 0) {
      stats.cleanSheets++;
    }

    if (homeGoals > 0 && awayGoals > 0) {
      stats.btts++;
    }

    if (awayGoals > homeGoals) {
      stats.wins++;
      stats.points += 3;
    } else if (awayGoals < homeGoals) {
      stats.losses++;
    } else {
      stats.draws++;
      stats.points += 1;
    }

    stats.ppg = stats.points / stats.played;
    stats.cleanSheetsPercentage = (stats.cleanSheets / stats.played) * 100;
    stats.bttsPercentage = (stats.btts / stats.played) * 100;
    stats.over15Percentage = (stats.over15 / stats.played) * 100;
    stats.over25Percentage = (stats.over25 / stats.played) * 100;

    awayStats.set(match.AwayTeam, stats);
  });

  return Array.from(awayStats.values());
};
